const drawer = document.querySelector('#size-chart');

if (drawer instanceof HTMLElement) {
  const unitToggle = drawer.querySelector('[data-size-unit-toggle]');

  if (unitToggle instanceof HTMLInputElement) {
    unitToggle.addEventListener('change', () => updateCharts(unitToggle.checked ? 'inch' : 'cm'));
  }

  const firstImage = drawer.querySelector('[data-size-chart-image]');
  const defaultUnit =
    unitToggle instanceof HTMLInputElement
      ? unitToggle.checked
        ? 'inch'
        : 'cm'
      : firstImage instanceof HTMLElement
        ? firstImage.dataset.sizeChartUnit
        : 'inch';

  updateCharts(defaultUnit);
}

function updateCharts(unit) {
  if (!(drawer instanceof HTMLElement)) return;

  const sizeChartImages = Array.from(drawer.querySelectorAll('[data-size-chart-image]'));
  if (sizeChartImages.length === 0) return;

  const chartAreas = [...new Set(sizeChartImages.map((image) => image.dataset.sizeChartArea))];
  const visibleImages = new Set(
    chartAreas.map(
      (area) =>
        sizeChartImages.find(
          (image) => image.dataset.sizeChartArea === area && image.dataset.sizeChartUnit === unit
        ) || sizeChartImages.find((image) => image.dataset.sizeChartArea === area)
    )
  );

  drawer.dataset.sizeUnit = unit;

  sizeChartImages.forEach((image) => {
    image.hidden = !visibleImages.has(image);
  });

  const unitToggle = drawer.querySelector('[data-size-unit-toggle]');
  if (unitToggle instanceof HTMLInputElement) unitToggle.checked = unit === 'inch';
}
